<template>
  <div>
    <b-row align-h="center" class="mb-4">
      <div id="pa-dimensions">
        <div class="diagram-container">
          <img :src="dimensionsImg" alt="dimensions-img" class="d-none d-md-block">
          <img :src="dimensionsImgLabeled" alt="dimensions-img-labeled" class="d-block d-md-none">

          <div class="input entry-device-1">
            <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de entrada</p>
              <b-select
                v-model="detailsForm.entry_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="entryExitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input remote-device">
            <ValidationProvider rules="required" name="Dispositivo a distancia" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo a distancia</p>
              <b-select
                v-model="detailsForm.remote_device"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input entry-sensor">
            <ValidationProvider rules="required" name="Sensor de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Sensor de entrada</p>
              <b-select
                v-model="detailsForm.entry_sensor"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="sensorsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input boom-length">
            <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1 }" name="Largo Asta" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Largo Asta</p>
              <b-select
                v-model="detailsForm.boom_length"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="boomLengthOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input alerts">
            <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Alertas</p>
              <b-select
                v-model="detailsForm.alerts"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="alertsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input support-post">
            <ValidationProvider rules="required" name="Poste de apoyo" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Poste de apoyo</p>
              <b-select
                v-model="detailsForm.support_post"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="supportPostOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input safety-sensors">
            <ValidationProvider rules="required" name="Sensores de seguridad" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Sensores de seguridad</p>
              <b-select
                v-model="detailsForm.safety_sensors"
                :options="sensorsOptions"
                :state="errors[0] ? false : (valid ? true : false)"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-1">
            <ValidationProvider rules="required" name="Dispositivo de salida 1" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de salida 1</p>
              <b-select
                v-model="detailsForm.exit_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="entryExitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-sensor">
            <ValidationProvider rules="required" name="Sensor de salida" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Sensor de salida</p>
              <b-select
                v-model="detailsForm.exit_sensor"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="sensorsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-2">
            <ValidationProvider rules="required" name="Dispositivo de salida 2" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de salida 2</p>
              <b-select
                v-model="detailsForm.exit_device_2"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </b-row>

    <!-- dimensions sm inputs -->
    <div class="d-block d-md-none">
      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de entrada" :blank="detailsForm.entry_device_1" show-reset @reset="detailsForm.entry_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="entryExitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo a distancia" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo a distancia" :blank="detailsForm.remote_device" show-reset @reset="detailsForm.remote_device = null" />
            </template>
            <b-select
              v-model="detailsForm.remote_device"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Sensor de entrada" style="width: 100%" v-slot="{ valid, errors }">

          <b-form-group class="w-100">
            <template #label>
              <Label label="Sensor de entrada" :blank="detailsForm.entry_sensor" show-reset @reset="detailsForm.entry_sensor = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_sensor"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="sensorsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1 }" name="Largo Asta" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Largo Asta" :blank="detailsForm.boom_length" show-reset @reset="detailsForm.boom_length = 0" />
            </template>
            <b-select
              v-model="detailsForm.boom_length"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="boomLengthOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Alertas" :blank="detailsForm.alerts" show-reset @reset="detailsForm.alerts = null" />
            </template>
            <b-select
              v-model="detailsForm.alerts"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="alertsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Poste de apoyo" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Poste de apoyo" :blank="detailsForm.support_post" show-reset @reset="detailsForm.support_post = null" />
            </template>
            <b-select
              v-model="detailsForm.support_post"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="supportPostOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Sensores de seguridad" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Sensores de seguridad" :blank="detailsForm.safety_sensors" show-reset @reset="detailsForm.safety_sensors = null" />
            </template>
            <b-select
              v-model="detailsForm.safety_sensors"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="sensorsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de salida 1" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida 1" :blank="detailsForm.exit_device_1" show-reset @reset="detailsForm.exit_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="entryExitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Sensor de salida" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Sensor de salida" :blank="detailsForm.exit_sensor" show-reset @reset="detailsForm.exit_sensor = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_sensor"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="sensorsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de salida 2" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida 2" :blank="detailsForm.exit_device_2" show-reset @reset="detailsForm.exit_device_2 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_2"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>
    </div>

    <b-row class="flex-column mb-2 mt-4">
      <Label label="Tipo de Barrera" :blank="controlAcceso.motor_id" />

      <b-row align-h="center" class="mt-3">
        <SelectableCard
          emptyTitle="No hay ninguna barrera seleccionada"
          :selected="controlAcceso.motor_id ? true : false"
          @open-selectable="$store.commit('setOpenModalName', 'motorSelector')"
        >
          <template #title>
            <span v-if="controlAcceso.motor_id">{{ controlAcceso.motor.item_code || '-' }}</span>
            <span v-else>Seleccione un tipo de barrera</span>
          </template>
          <template #selected-content>
            <b-row align-h="center">
              <b-img v-if="controlAcceso.motor_image_url" :src="controlAcceso.motor_image_url" />
              <div v-else class="d-flex align-items-center justify-content-center" style="width: 100px; height: 50px;">
                <font-awesome-icon :icon="['far', 'image']" size="2x" class="text-muted" fixed-width />
              </div>
            </b-row>
            <div class="mt-3 self-align-end">
              <Button
                variant="blue"
                @click="$store.commit('setOpenModalName', 'motorSelector')"
              >
                Cambiar
              </Button>
            </div>
          </template>
        </SelectableCard>
      </b-row>
    </b-row>

    <b-row class="flex-column mb-2">
      <Label
        label="Breakaway (Sistema pivotante/desmontable)"
        :blank="detailsForm.breakaway === null ? null : 'true'"
        :show-reset="detailsForm.breakaway == true || detailsForm.breakaway == false"
        @reset="detailsForm.breakaway = null"
      />
      <b-form-group>
        <b-radio-group size="lg" v-model="detailsForm.breakaway" class="ml-4">
          <b-radio :value="true">
            Si
          </b-radio>
          <b-radio :value="false">
            No
          </b-radio>
        </b-radio-group>
      </b-form-group>
    </b-row>

    <b-row class="flex-column mb-2">
      <Label
        label="Articulación"
        :blank="detailsForm.articulated === null ? null : 'true'"
        :show-reset="detailsForm.articulated == true || detailsForm.articulated == false"
        @reset="detailsForm.articulated = null"
      >
        <template #feedback>
          <FeedbackMessage
            v-if="detailsForm.articulated == true"
            type="warning"
          >
            <template #default>
              Debe considerar todos los obstáculos/dimensiones del buque para el recorrido del asta con el sistema de articulación de la barrera automática
            </template>
          </FeedbackMessage>
        </template>
      </Label>
      <b-form-group>
        <b-radio-group size="lg" v-model="detailsForm.articulated" class="ml-4">
          <b-radio :value="true">
            Si
          </b-radio>
          <b-radio :value="false">
            No
          </b-radio>
        </b-radio-group>
      </b-form-group>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

import Label from '../../Label'
import Button from '../../../../shared/Button'
import SelectableCard from '../../../configurators/SelectableCard'
import FeedbackMessage from '../../FeedbackMessage.vue'

import {
  entryExitDevicesOptions,
  communicationDevicesOptions,
  sensorsOptions,
  boomLengthOptions,
  supportPostOptions,
  alertsOptions,
} from '../../../../../sharedOptions/controlesAccesoModule'


export default {
  name: 'barreraAutomatica',
  components: {
    Label,
    Button,
    FeedbackMessage,
    SelectableCard,
    ValidationProvider
  },
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      dimensionsImg: require('../../../../../../assets/images/control_acceso/barrera_automatica.png'),
      dimensionsImgLabeled: require('../../../../../../assets/images/control_acceso/barrera_automatica_labeled.png'),
      entryExitDevicesOptions: entryExitDevicesOptions,
      communicationDevicesOptions: communicationDevicesOptions,
      sensorsOptions: sensorsOptions,
      boomLengthOptions: boomLengthOptions,
      supportPostOptions: supportPostOptions,
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    alertsOptions() {
      return alertsOptions.filter(option => option.value !== 'Intermitente')
    },
  }
}
</script>

<style scoped lang="scss">
  #pa-dimensions {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      max-width: 62.5rem;

      img {
        width: 100%;
        height: auto;
        align-self: center;
      }
    }

    .input {
      position: absolute;
      z-index: 10;
      min-width: 180px;
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: rgba(255, 255, 255, 0.94);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      .label {
        display: none;
        font-size: 11px;
        font-weight: 600;
        margin-bottom: 0;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
      }
    }
    // inputs
    .entry-device-1 {
      top: 2%;
      left: 36%;
    }
    .remote-device {
      top: 9%;
      left: 37%;
    }
    .entry-sensor {
      top: 17%;
      left: 44%;
    }
    .boom-length {
      top: 25%;
      right: 19%;
    }
    .alerts {
      top: 32%;
      right: 20%;
    }
    .support-post {
      top: 40%;
      right: 16%;
    }
    .safety-sensors {
      left: 6%;
      bottom: 28%;
    }
    .exit-device-1 {
      bottom: 3%;
      left: 41%;
    }
    .exit-sensor {
      bottom: 18%;
      left: 11%;
    }
    .exit-device-2 {
      bottom: 10%;
      right: 45%;
    }
  }

  @media (max-width: 768px) {
    #pa-dimensions {
      .input {
        min-width: 0;
        width: auto;
        padding: 0px;
        border: none;
        background: rgba(255, 255, 255, 0.94);
        box-shadow: none;

        select {
          display: none
        }

        .label {
          // display: block;
          font-size: 7px;
          font-weight: 600;
          color: #333;
          white-space: nowrap;
          letter-spacing: normal;
          margin: 0;
        }

        &:hover {
          border: none;
          transform: none;
        }
      }

      .entry-device-1 {
        top: 3%;
        left: 36%;
      }
      .remote-device {
        top: 10%;
        left: 37%;
      }
      .entry-sensor {
        top: 17%;
        left: 48%;
      }
      .boom-length {
        top: 25%;
        right: 19%;
      }
      .alerts {
        top: 32%;
        right: 20%;
      }
      .support-post {
        top: 41%;
        right: 16%;
      }
      .safety-sensors {
        left: 6%;
        bottom: 30%;
      }
      .exit-device-1 {
        bottom: 4%;
        left: 41%;
      }
      .exit-sensor {
        bottom: 19%;
        left: 14%;
      }
      .exit-device-2 {
        bottom: 11%;
        right: 45%;
      }
    }
  }
</style>
